module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="action-properties"></div>\n<div class="analytics-properties"></div>\n<div class="size-and-position-properties"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/linkWidget/LinkWidgetPropertiesView.tpl
// module id = 2051
// module chunks = 0